export const resolveRemedialCurveDisplayRange = (
  times: number[],
  intervalH: number,
  delayH: number,
): [number, number] | undefined => {
  if (!times.length || !Number.isFinite(intervalH) || intervalH <= 0) return undefined;
  const finiteTimes = times.map(Number).filter(Number.isFinite);
  if (!finiteTimes.length) return undefined;
  const fullStart = Math.min(...finiteTimes);
  const fullEnd = Math.max(...finiteTimes);
  const displayEnd = Math.min(fullEnd, Math.max(Number(delayH || 0) + 2 * intervalH, 5 * intervalH));
  return [Math.max(fullStart, -intervalH), displayEnd];
};
